module.exports = {"name":"Online RMUTL","short_name":"Online RMUTL","icons":[{"src":"/static/img/icons/android-chrome-192x192.png","sizes":"192x192","type":"image/png"},{"src":"/static/img/icons/android-chrome-512x512.png","sizes":"512x512","type":"image/png"}],"start_url":"/","display":"standalone","background_color":"#000000","theme_color":"#4DBA87","base_api":"","version":"0.1"}


//////////////////
// WEBPACK FOOTER
// ./static/manifest.json
// module id = 161
// module chunks = 2